import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { IReporteVentaCorporativaPagingRes, IReporteVentaCorporativaParams } from "@/shared/interfaces";
import { getUrlParamsFetch } from "@/shared/utils";
import { useQuery } from "@tanstack/react-query";

const { get } = erpApi();

export const useFetchReporteGeneralCorporativo = (params?: IReporteVentaCorporativaParams) => {

  return useQuery({
    queryKey: ['buscador-general-corporativo', ...Object.values(params || {})],
    queryFn: async () => {
      return await getBuscadorGeneral(params)
    },
    retry: false
  })
}

export const getBuscadorGeneral = async (params?: IReporteVentaCorporativaParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = get<IReporteVentaCorporativaPagingRes>(
    `${urlBackend}api/v1/buscador-general-corporativo/?${queryParams}`,
    true
  );
  return resp;
};